import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from './messages';

const MediumLayout = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="caerus-brand-container d-flex flex-column align-items-center justify-content-center">
      {/* Logo nativo para evitar problemas con Paragon */}
      <a href={getConfig().MARKETING_SITE_BASE_URL || '/'}>
        <img
          src={getConfig().LOGO_URL}
          alt={getConfig().SITE_NAME}
          className="logo"
          style={{ display: 'block', height: '110px', width: 'auto', margin: '0 auto' }}
        />
      </a>

      {/* Heading con cada parte en su propia línea */}
      <h1 className="main-heading mt-3 mb-0" style={{ textAlign: 'center' }}>
        <span style={{ display: 'block' }}>
          {formatMessage(messages['start.learning'])}
        </span>
        <span className="text-accent-a" style={{ display: 'block' }}>
          {formatMessage(messages['with.site.name'], { siteName: getConfig().SITE_NAME })}
        </span>
      </h1>

      {/* Créditos */}
      <div className="powered-by-container d-flex align-items-center mt-2">
        <p className="powered-by-cincinatus mb-0 mr-1">
          Desarrollado por:
        </p>
        <a href="https://cincinnatus.edu.do/" target="_blank" rel="noopener noreferrer">
          Cincinnatus
        </a>
      </div>
    </div>
  );
};

export default MediumLayout;
